import React from "react";
import UserToClientList from "./UserToClientList";
import { RemovableUserToClient } from "components/Removables/RemovableUserToClient";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import { ModalPickerProps } from "../props";

interface Props extends ModalPickerProps<server.dto.UserToClientSmall> {
  canChooseDeactivated?: boolean
  canChooseExternal?: boolean

  customLabel?: string
  excludeUserIds?: number[]
}

const UserToClientModalPicker = (props: Props) => {
  const { canChooseDeactivated, canChooseExternal, customLabel, excludeUserIds, ...rest } = props;
  const onChange = (value: server.dto.UserToClientSmall) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };

  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={RESX.Buttons.btnSelect}
    modalTitle={props.customLabel ?? RESX.SoUser.Users}
    modalSize="tiny"

    renderModalContent={(closeModal) => <UserToClientList
      excludedUsers={props.excludeUserIds}
      onUserSelected={(userToClient) => {
        closeModal();
        onChange(userToClient);
      }}
      canChooseDeactivated={props.canChooseDeactivated}
      canChooseExternal={props.canChooseExternal}
    />}
    renderRemovable={(props) => <RemovableUserToClient {...props} />}
    {...rest}
  />;
};

export default UserToClientModalPicker;